
"use strict"

import search from './search/main'
import savedJobs from './search/savedJobs'
import latestJobs from './search/latestJobs'

import toggleFiltersMobile from './components/toggleFiltersMobile'
import hero from './components/hero'
import expand from './components/expand'
import scrollCards from './components/scrollCards'
import bgColourFade from './components/bgColourFade'
import videoLightbox from './components/video'
import logoCarousel from './components/logoCarousel'

import { setupHtmlVars as cursorsetupHtmlVars } from './utility/cursor'
import nav from './components/nav'
import mobileNav from './components/mobileNav'
import tabs from './components/tabs'
import scrollPosition from './components/scrollPosition'
import trackToHire from './components/trackToHire'
// import fixedNav from './components/fixedNav'

import './components/load-row'
import './components/cursor'
import './components/tabbedContent'
import './components/mobileNavigation'
import './components/brandModal'



search()
savedJobs()
latestJobs()
toggleFiltersMobile()

hero()
nav()
mobileNav()
tabs()
scrollPosition()
bgColourFade()
logoCarousel()
scrollCards()
cursorsetupHtmlVars()
videoLightbox()
trackToHire()
// fixedNav()

expand('.accordion__button', (open, button, content) => {
	const openClass = 'is-open'
	open ? button.parentNode.classList.add(openClass) : button.parentNode.classList.remove(openClass)
})

document.documentElement.classList.remove('no-js')
document.documentElement.classList.add('js')